import {Stack} from '@mui/material';
import styled from 'styled-components';

const CustomBox = styled(Stack)<{$isMobOrTab?: boolean}>`
	padding: ${({$isMobOrTab}) => ($isMobOrTab ? '16px 16px 76px' : '16px')};
	min-height: ${({$isMobOrTab}) => ($isMobOrTab ? 'calc(100vh - 72px)' : 'fit-content')};
	border-radius: ${({$isMobOrTab}) => ($isMobOrTab ? '0px' : '8px')};
	gap: 16px;
	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;

export {CustomBox};
